import React from "react";
import { motion } from "framer-motion";
import AnimatedButton from "../components/AnimatedButton";
import Header from "../components/Header";
import Footer from "../components/Footer";
import GameCard from "../components/GameCard";
import { gamesData } from "../data/gamesData";
import FloatingStats from "../components/FloatingStats";
import { FaTrophy, FaPuzzlePiece, FaDownload, FaStar, FaApple, FaGooglePlay, FaInstagram, FaTwitter, FaFacebookF } from "react-icons/fa";
import gridPattern from "../assets/images/grid-pattern.svg";
import poster from "../assets/images/toddlers-game.jpg";
import trailer from "../assets/videos/toddlersvideo.mp4";
import { useRef, useEffect, useState } from "react";
import { VolumeX, Volume2 } from "lucide-react";
import { UI_AssetMap } from "../components/utils/imageMap";
import { AppStoreUrl, PlayStoreUrl } from "../components/utils/constent";



const reviews = [
  {
    name: "Preeti Yadav",
    rating: 5,
    text: "Kids love this game's lively animations! It makes learning feel like playtime. Great for keeping little ones engaged and entertained.",
    avatar: "👩👧",
  },
  {
    name: "Sanjeet",
    rating: 5,
    text: "This kids learning game is packed with animation that will keep kids entertained and making learning exciting for kids.",
    avatar: "👨👦",
  },
  {
    name: "AJAY DHADE",
    rating: 5,
    text: "This app is very good for kids because they can study along with playing games on this application.",
    avatar: "👩👦👦",
  },
  {
    name: "Sitaram Mahajan",
    rating: 5,
    text: "This app is a fantastic and engaging way to learn about fruits , animals! The interactive games and vibrant visuals make it easy and fun to discover new fruits, animals their names",
    avatar: "👩👦👦",
  },
];
const LandingPage = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);




  // const cardVariants = {
  //   hidden: {
  //     opacity: 0,
  //     y: 60,
  //   },
  //   show: {
  //     opacity: 1,
  //     y: 0,
  //     transition: {
  //       duration: 0.5,
  //       ease: "easeOut",
  //     },
  //   },
  // };

  // useEffect(() => {
  //   if (videoRef.current) {
  //     videoRef.current.playbackRate = 0.8;
  //   }
  // }, []);

  // const toggleMute = () => {
  //   if (videoRef.current) {
  //     videoRef.current.muted = !isMuted;
  //     setIsMuted(!isMuted);
  //   }
  // };

  // const ReviewCard = ({ review, positionClass }) => (
  //   <motion.div
  //     initial={{ opacity: 0, x: positionClass.includes("left") ? -50 : 50 }}
  //     animate={{ opacity: 1, x: 0 }}
  //     transition={{ delay: 0.5 }}
  //     className={`hidden md:block absolute ${positionClass} transform -translate-y-1/2 w-72 z-20`}
  //   >
  //     <div className="bg-gradient-to-br from-purple-900/80 to-cyan-900/80 p-6 rounded-2xl backdrop-blur-sm border-2 border-cyan-400/30 shadow-xl">
  //       <div className="flex items-center gap-3 mb-4">
  //         <div className="text-3xl">{review.avatar}</div>
  //         <div>
  //           <h4 className="text-cyan-100 font-bold">{review.name}</h4>
  //           <div className="flex gap-1 text-yellow-400">
  //             {[...Array(review.rating)].map((_, i) => (
  //               <FaStar key={i} className="w-4 h-4" />
  //             ))}
  //           </div>
  //         </div>
  //       </div>
  //       <p className="text-cyan-50 italic">"{review.text}"</p>
  //     </div>
  //   </motion.div>
  // );

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.25,
    },
  },
};

const cardVariants = {
  hidden: {
    opacity: 0,
    y: 60,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};


  return (
    <div>
      <div
        style={{
          backgroundImage: `url(${UI_AssetMap.Background_Img})`,
          minHeight: "100vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Header />

        {/* Hero Section */}
        <section className="relative pt-[24%] md:pt-[10%] pb-[5%] px-[5%]">
          <div className="max-w-[90%] mx-auto grid lg:grid-cols-2 items-center gap-[5%]">
            {/* LEFT CONTENT */}
            <motion.div
              initial={{ opacity: 0, x: "-10%" }}
              animate={{ opacity: 1, x: "0%" }}
              transition={{ duration: 0.6 }}
            >
              <h1 className="font-baloo text-[2.5rem] md:text-[3rem] xl:text-[3.8rem] leading-tight font-bold">
                <span className="text-[#FF6B2C] font-baloo font-bold">
                  Fun Learning
                </span>{" "}
                <br />
                <span className="text-[#FF6B2C]">Games</span>{" "}
                <span className="text-[#2F3E5C]">for Kids!</span>
              </h1>

              <p className="font-baloo font-semibold mt-[2%] text-[1.1rem] text-[#5F6C8C] max-w-[80%] ">
                Exciting and educational games that make learning fun and
                engaging!
              </p>

              <p className="font-baloo font-medium mt-[1.5%] text-[1.1rem] text-[#2F3E5C] ">
                Choose your child’s favorite learning game below
              </p>

              {/* STORE BUTTONS */}
              <div className="flex gap-[3%] mt-[16%] flex-wrap justify-center items-center md:justify-start">
                {/* App Store Button */}
                <a
                  href={AppStoreUrl} // Replace with your app's App Store link
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-[45%] md:w-[40%] lg:w-[35%] cursor-pointer transform transition-transform duration-300 hover:scale-110 "
                >
                  <img
                    src={UI_AssetMap.AppStore_Btn}
                    alt="App Store"
                    className="w-full object-contain rounded-2xl shadow-xl"
                  />
                </a>

                {/* Play Store Button */}
                <a
                  href={PlayStoreUrl} // Replace with your app's Play Store link
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-[45%] md:w-[40%]  lg:w-[35%] cursor-pointer transform transition-transform duration-300 hover:scale-110 "
                >
                  <img
                    src={UI_AssetMap.PlayStore_Btn}
                    alt="Google Play"
                    className="w-full object-contain rounded-2xl shadow-xl"
                  />
                </a>
              </div>
            </motion.div>

            {/* RIGHT IMAGE */}
            <motion.div
              className="flex justify-center mt-[15%] md:[mt-0 justify-end] "
              initial={{ opacity: 0, x: "10%" }}
              animate={{ opacity: 1, x: "0%" }}
              transition={{ duration: 0.6 }}
            >
              <div className="absolute min-w-full md:w-1/2 md:relative  ">
                <img
                  src={UI_AssetMap.HeroSection.x1}
                  srcSet={`
                  ${UI_AssetMap.HeroSection.x1} 1x,
                    ${UI_AssetMap.HeroSection.x2} 2x,
                    ${UI_AssetMap.HeroSection.x3} 3x
                 `}
                  alt="Kids learning apps"
                  className="w-full max-w-[750px] h-auto object-contain"
                />
              </div>
            </motion.div>
          </div>
        </section>
      </div>

      {/* Featured Games Section */}
      <section
        className="relative py-16 px-[5%] shadow-xl bg-cover bg-center"
        style={{
          backgroundImage: `url(${UI_AssetMap.Texture_Img})`,
        }}
      >
        <div className="relative max-w-[100%] mx-auto">
          {/* TITLE */}
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-[2rem] md:text-[3rem] font-baloo font-bold text-center text-[#2F3E5C] mb-12 "
          >
            Our Learning Apps
          </motion.h2>

          {/* GAME CARDS */}
          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-14 max-w-6xl mx-auto"
            variants={containerVariants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
          >
            {gamesData.map((game) => (
              <motion.div
                key={game.id}
                variants={cardVariants}
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <GameCard game={game} />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Enhanced Features Section */}
      <section className="relative py-10 px-5 text-center">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src={UI_AssetMap.ParentLove_BG_Img} // Desktop background
            alt="Background"
            className="hidden md:block w-full h-full object-cover"
          />
          <img
            src={UI_AssetMap.ParentLove_BG_Img} // Mobile background
            alt="Background"
            className="block md:hidden w-full h-full object-cover"
          />
          {/* <div className="absolute inset-0 bg-[#fff7f2]/90"></div>{" "} */}
          {/* overlay for contrast */}
        </div>

        {/* Why Parent Chose This Block */}
        <div className="relative max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-baloo font-bold text-gray-800 mb-12 relative z-10">
            Why Parents Love <span className="text-orange-500">Twepple</span>
          </h2>

          <motion.div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 relative z-10">
            {/* Card 1 */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, margin: "-100px" }}
              className="flex flex-col items-center bg-white rounded-2xl p-6 shadow-md hover:shadow-xl hover:scale-105"
            >
              <img
                src={UI_AssetMap.Safe_Secure_Img}
                className="w-30 mb-4"
                alt="Safe"
              />
              <h3 className="text-lg font-baloo font-semibold text-gray-800">
                Safe & Kid-Friendly
              </h3>
              <p className="text-gray-500 text-sm mt-1 font-baloo font-medium">
                Ad-free and secure
              </p>
            </motion.div>

            {/* Card 2 */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, margin: "-100px" }}
              className="flex flex-col items-center bg-white rounded-2xl p-6 shadow-md hover:shadow-xl hover:scale-105"
            >
              <img
                src={UI_AssetMap.Education_Fun_Img}
                className="w-30 mb-4"
                alt="Education"
              />
              <h3 className="text-lg font-baloo font-semibold text-gray-800">
                Educational & Fun
              </h3>
              <p className="text-gray-500 text-sm mt-1 font-baloo font-medium">
                Learn while playing
              </p>
            </motion.div>

            {/* Card 3 */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, margin: "-100px" }}
              className="flex flex-col items-center bg-white rounded-2xl p-6 shadow-md hover:shadow-xl hover:scale-105"
            >
              <img
                src={UI_AssetMap.BoostCreativity_Img}
                className="w-30 mb-4"
                alt="Creativity"
              />
              <h3 className="text-lg font-baloo font-semibold text-gray-800">
                Boosts Creativity
              </h3>
              <p className="text-gray-500 font-baloo font-medium text-sm mt-1">
                Inspires imagination
              </p>
            </motion.div>

            {/* Card 4 */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, margin: "-100px" }}
              className="flex flex-col items-center bg-white rounded-2xl p-6 shadow-md hover:shadow-xl hover:scale-105"
            >
              <img
                src={UI_AssetMap.EasyToUse_Img}
                className="w-30 mb-4"
                alt="Easy"
              />
              <h3 className="text-lg  text-gray-800 font-baloo font-semibold ">
                Easy to Use
              </h3>
              <p className="text-gray-500 text-sm mt-1 font-baloo font-medium">
                Simple for kids
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <section className="relative w-full flex items-center justify-center">
        {/* Background Image */}
        <img
          src={UI_AssetMap.Bottom_Banner_Img.x1}
          srcSet={`
              ${UI_AssetMap.Bottom_Banner_Img.x1} 1x,
              ${UI_AssetMap.Bottom_Banner_Img.x2} 2x,
              ${UI_AssetMap.Bottom_Banner_Img.x3} 3x
            `}
          alt="Kids playing"
          className="w-full h-auto object-cover"
        />

        {/* Overlay Text */}
        <div className="absolute top-[2%] md:top-[14%] left-1/2 transform -translate-x-1/2 text-center w-screen">
          <h2 className="text-[1.3rem] xsss:text-[1.55rem] xss:text-[1.7rem] md:text-5xl font-baloo  font-bold text-[#052161] px-4">
            Kids Love Playing Our Apps!
          </h2>
        </div>
      </section>

      <section
        className="relative py-10 px-5 shadow-xl bg-cover bg-center"
        style={{
          backgroundImage: `url(${UI_AssetMap.Texture_Img})`,
        }}
      >
        <div className="w-full mx-auto text-center">
          <h2 className="text-[32px] md:text-[38px] font-baloo font-bold text-[#2F3E5C]">
            Get Started with <span className="text-[#FF6B2C]">Twepple</span>{" "}
            Today!
          </h2>

          <p className="text-[#5F6C8C] mt-3 text-lg font-baloo font-medium">
            Download our fun learning games now!
          </p>

          <div className="flex justify-center items-center gap-6 mt-10">
            <a
              href={AppStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="transform transition duration-300 hover:scale-105 rounded-2xl md:rounded-3xl shadow-xl"
            >
              <img
                src={UI_AssetMap.AppStore_Btn}
                alt="Download on App Store"
                className="h-[60px] md:h-[90px] object-contain rounded-2xl md:rounded-3xl shadow-xl"
              />
            </a>

            <a
              href={PlayStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="transform transition duration-300 hover:scale-105 rounded-2xl md:rounded-3xl shadow-xl"
            >
              <img
                src={UI_AssetMap.PlayStore_Btn}
                alt="Get it on Google Play"
                className="h-[60px] md:h-[90px] object-contain rounded-2xl md:rounded-3xl shadow-xl"
              />
            </a>
          </div>
        </div>
      </section>

      {/* footer */}

      <Footer />
    </div>

    // <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 font-['Comic_Neue']">

    //   {/* Hero Section */}
    //   <section className="relative min-h-screen flex flex-col items-center justify-center pt-16 pb-20 md:pt-24 md:pb-22 overflow-hidden">
    //     <div className="relative z-10 text-center px-4 flex-1 flex flex-col items-center justify-center w-full max-w-7xl">
    //       {/* Reviews positioned around the video */}
    //       <ReviewCard
    //         review={reviews[0]}
    //         positionClass="left-[-5%] top-[15%]"
    //       />
    //       <ReviewCard
    //         review={reviews[1]}
    //         positionClass="left-[-5%] top-[50%]"
    //       />
    //       <ReviewCard
    //         review={reviews[2]}
    //         positionClass="right-[-5%] top-[15%]"
    //       />
    //       <ReviewCard
    //         review={reviews[3]}
    //         positionClass="right-[-5%] top-[42%]"
    //       />

    //       {/* Enhanced Main Heading */}
    //       <motion.div
    //         initial={{ opacity: 0 }}
    //         animate={{ opacity: 1 }}
    //         className="relative mb-8"
    //       >
    //         <div className="absolute inset-0 bg-gradient-to-r from-cyan-400/20 to-purple-400/20 blur-3xl opacity-30" />
    //         <h1 className="text-3xl md:text-6xl font-bold mb-6 leading-tight">
    //           <span className="bg-gradient-to-r from-yellow-300 to-pink-400 bg-clip-text text-transparent px-2">
    //             Toddlers
    //           </span>
    //           <span className="text-white px-2">Learning</span>
    //           <span className="bg-gradient-to-r from-pink-400 to-yellow-300 bg-clip-text text-transparent px-2">
    //             Games
    //           </span>
    //         </h1>
    //       </motion.div>

    //       {/* Animated Subheading */}
    //       <motion.p
    //         className="text-2xl md:text-3xl lg:text-4xl text-white mb-8 max-w-4xl mx-auto font-light tracking-wide"
    //         initial={{ opacity: 0 }}
    //         animate={{ opacity: 1 }}
    //         transition={{ delay: 0.2 }}
    //       >
    //         Where <span className="text-cyan-300 font-semibold">Curiosity</span>{" "}
    //         Meets
    //         <span className="text-purple-300 font-semibold"> Creativity</span>
    //       </motion.p>

    //       {/* Enhanced Video Container */}
    //       <motion.div
    //         className="relative w-full max-w-2xl mb-10 md:mb-14"
    //         initial={{ scale: 0.9, opacity: 0 }}
    //         animate={{ scale: 1, opacity: 1 }}
    //         transition={{ delay: 0.3 }}
    //       >
    //         <div className="relative device-frame bg-gray-800 rounded-[40px] p-4 shadow-2xl transform perspective-1000 border-4 border-cyan-400/20 hover:border-purple-400/40 transition-all">
    //           {/* Video element with working mute button */}
    //           <div className="relative rounded-[32px] overflow-hidden aspect-video border-4 border-gray-900/50">
    //             <video
    //               ref={videoRef}
    //               className="w-full h-full object-cover"
    //               autoPlay
    //               muted
    //               loop
    //               playsInline
    //               poster={poster}
    //             >
    //               <source src={trailer} type="video/mp4" />
    //             </video>
    //             <button
    //               onClick={toggleMute}
    //               className="absolute bottom-4 right-4 bg-gray-900/75 p-2 rounded-full text-white hover:bg-gray-700 backdrop-blur-sm z-50"
    //             >
    //               {isMuted ? <VolumeX size={24} /> : <Volume2 size={24} />}
    //             </button>
    //           </div>

    //           {/* Glowing Effects */}
    //           <div className="absolute -inset-8 bg-gradient-to-r from-cyan-400/20 to-purple-400/20 blur-2xl opacity-20 animate-pulse" />
    //         </div>

    //         {/* Animated Decorations */}
    //         <motion.div
    //           className="absolute -top-8 -left-8 text-6xl"
    //           animate={{ y: [0, -20, 0], rotate: [0, 360] }}
    //           transition={{ duration: 8, repeat: Infinity }}
    //         >
    //           🧩
    //         </motion.div>
    //         <motion.div
    //           className="absolute -bottom-8 -right-8 text-6xl"
    //           animate={{ y: [0, -20, 0], rotate: [360, 0] }}
    //           transition={{ duration: 8, repeat: Infinity, delay: 2 }}
    //         >
    //           🎨
    //         </motion.div>
    //       </motion.div>

    //       {/* Enhanced Download Buttons */}
    //       <div className="flex flex-col md:flex-row gap-6 justify-center w-full max-w-2xl">
    //         <a
    //           href="https://play.google.com/store/apps/details?id=com.twepple.baby.toddler.kids.preschool.learning.activity.games&hl=en_USr"
    //           target="_blank"
    //           rel="noopener noreferrer"
    //         >
    //           <AnimatedButton
    //             text="Get on Play Store"
    //             icon="android"
    //             color="green"
    //             className="text-xl py-4 shadow-lg shadow-green-500/30 hover:shadow-green-500/50 transform hover:scale-105 transition-transform"
    //           />
    //         </a>
    //         <a
    //           href="https://apps.apple.com/us/app/kids-games-for-toddlers-2-to-6/id6736658511"
    //           target="_blank"
    //           rel="noopener noreferrer"
    //         >
    //           <AnimatedButton
    //             text="Download on App Store"
    //             icon="apple"
    //             className="text-xl py-4 shadow-lg shadow-purple-500/30 hover:shadow-purple-500/50 transform hover:scale-105 transition-transform"
    //           />
    //         </a>
    //       </div>
    //     </div>

    //     <div className="w-full px-4 mt-20 md:mt-20">
    //       <FloatingStats />
    //     </div>
    //   </section>

    //   {/* Featured Games Section */}
    //   <section className="py-10 px-6 bg-gradient-to-b from-cyan-900/20 to-purple-900/20">
    //     <motion.h2
    //       initial={{ opacity: 0 }}
    //       whileInView={{ opacity: 1 }}
    //       className="text-5xl font-bold text-center text-transparent bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text mb-16"
    //     >
    //       Our Magical World
    //     </motion.h2>
    //     <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">
    //       {gamesData.slice(0, 3).map((game) => (
    //         <motion.div
    //           key={game.id}
    //           whileHover={{ scale: 1.05 }}
    //           transition={{ type: "spring", stiffness: 300 }}
    //         >
    //           <GameCard game={game} />
    //         </motion.div>
    //       ))}
    //     </div>
    //   </section>

    //   {/* CTA Section */}
    //   <section className="py-20 px-6 relative overflow-hidden">
    //     <div className="absolute inset-0 z-0">
    //       <motion.div
    //         className="absolute w-96 h-96 bg-purple-500 rounded-full blur-3xl opacity-20 -top-32 -left-32"
    //         animate={{
    //           scale: [1, 1.2, 1],
    //           opacity: [0.2, 0.4, 0.2],
    //         }}
    //         transition={{
    //           duration: 4,
    //           repeat: Infinity,
    //         }}
    //       />
    //       <motion.div
    //         className="absolute w-96 h-96 bg-cyan-500 rounded-full blur-3xl opacity-20 -bottom-32 -right-32"
    //         animate={{
    //           scale: [1, 1.2, 1],
    //           opacity: [0.2, 0.4, 0.2],
    //         }}
    //         transition={{
    //           duration: 4,
    //           repeat: Infinity,
    //           delay: 2,
    //         }}
    //       />
    //     </div>

    //     <motion.div
    //       className="max-w-6xl mx-auto relative bg-gradient-to-br from-cyan-900/40 to-purple-900/40 rounded-[40px] p-12 text-center backdrop-blur-2xl border-2 border-cyan-400/30 shadow-2xl overflow-hidden"
    //       initial={{ scale: 0.95, opacity: 0 }}
    //       whileInView={{ scale: 1, opacity: 1 }}
    //     >
    //       <div
    //         style={{ backgroundImage: `url(${gridPattern})`, opacity: 0.1 }}
    //         className="absolute inset-0"
    //       />
    //       <div className="relative z-10">
    //         <h2 className="text-4xl md:text-5xl font-bold mb-6">
    //           <span className="text-transparent bg-gradient-to-r from-cyan-300 to-purple-300 bg-clip-text">
    //             Start Your
    //           </span>
    //           <span className="block mt-2 text-cyan-100">
    //             Learning Adventure!
    //           </span>
    //         </h2>
    //         <p className="text-xl md:text-2xl text-cyan-200 mb-8 max-w-2xl mx-auto leading-relaxed">
    //           Join millions of parents in our award-winning educational universe
    //         </p>
    //         <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
    //           {[
    //             {
    //               text: "Google Play",
    //               icon: "android",
    //               color: "from-green-400 to-cyan-400",
    //               href: "https://play.google.com/store/apps/details?id=com.twepple.baby.toddler.kids.preschool.learning.activity.games&hl=en_USr",
    //               target: "_blank",
    //               rel: "noopener noreferrer",
    //             },
    //             {
    //               text: "App Store",
    //               icon: "apple",
    //               color: "from-purple-400 to-pink-400",
    //               href: "https://apps.apple.com/us/app/kids-games-for-toddlers-2-to-6/id6736658511",
    //               target: "_blank",
    //               rel: "noopener noreferrer",
    //             },
    //           ].map((btn, i) => (
    //             <motion.a
    //               key={btn.text}
    //               whileHover={{ scale: 1.05 }}
    //               whileTap={{ scale: 0.95 }}
    //               href={btn.href}
    //               target="_blank" // Added to open in a new tab
    //               rel="noopener noreferrer"
    //               className={`bg-gradient-to-r ${btn.color} text-gray-900 px-8 py-4 rounded-2xl font-bold flex items-center gap-3 transition-all hover:shadow-lg`}
    //             >
    //               <span className="text-xl">
    //                 {btn.icon === "apple" ? "" : "▶"}
    //               </span>
    //               {btn.text}
    //             </motion.a>
    //           ))}
    //         </div>
    //         <div className="mt-8 flex items-center justify-center gap-4">
    //           <motion.div
    //             className="flex items-center gap-2 text-cyan-300"
    //             animate={{
    //               y: [-5, 5, -5],
    //               transition: {
    //                 duration: 3,
    //                 repeat: Infinity,
    //               },
    //             }}
    //           >
    //             <FaTrophy className="text-3xl" />
    //             <span className="text-xl">4.9/5 Ratings</span>
    //             <FaPuzzlePiece className="text-3xl" />
    //           </motion.div>
    //         </div>
    //       </div>
    //     </motion.div>
    //   </section>

    //   {/* Enhanced Features Section */}
    //   <section className="py-20 px-6 bg-gradient-to-b from-purple-900/20 to-cyan-900/20">
    //     <div className="max-w-6xl mx-auto">
    //       <h3 className="text-4xl font-bold text-center text-transparent bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text mb-16">
    //         Why Families Choose Us
    //       </h3>
    //       <div className="grid md:grid-cols-3 gap-8">
    //         {[
    //           {
    //             icon: <FaDownload className="text-5xl mb-4 text-purple-300" />,
    //             title: "Instant Fun",
    //             text: "Download & start learning in seconds",
    //             color: "from-purple-500/30 to-cyan-500/30",
    //           },
    //           {
    //             icon: <FaPuzzlePiece className="text-5xl mb-4 text-cyan-300" />,
    //             title: "Daily Discoveries",
    //             text: "New educational content every day",
    //             color: "from-cyan-500/30 to-purple-500/30",
    //           },
    //           {
    //             icon: <FaTrophy className="text-5xl mb-4 text-yellow-300" />,
    //             title: "Progress Tracking",
    //             text: "Watch your child's skills grow",
    //             color: "from-yellow-500/30 to-pink-500/30",
    //           },
    //         ].map((feature, index) => (
    //           <motion.div
    //             key={index}
    //             className="p-8 bg-gradient-to-br from-cyan-900/30 to-purple-900/30 rounded-3xl backdrop-blur-sm hover:backdrop-blur-md transition-all relative overflow-hidden group"
    //             whileHover={{ y: -10 }}
    //           >
    //             {/* Animated Border */}
    //             <div className="absolute inset-0 rounded-3xl p-[2px] bg-gradient-to-br from-purple-400  opacity-40 group-hover:opacity-100 transition-opacity">
    //               <div className="absolute inset-0 bg-gradient-to-br from-gray-600 to-cyan-800 animate-spin-slow opacity-0 group-hover:opacity-20" />
    //             </div>

    //             <div className="relative">
    //               <motion.div
    //                 className="inline-block mb-6"
    //                 whileHover={{ scale: 1.2, rotate: 360 }}
    //                 transition={{ type: "spring" }}
    //               >
    //                 {feature.icon}
    //               </motion.div>
    //               <h4 className="text-2xl font-bold text-cyan-100 mb-4">
    //                 {feature.title}
    //               </h4>
    //               <p className="text-lg text-cyan-50">{feature.text}</p>
    //             </div>
    //           </motion.div>
    //         ))}
    //       </div>
    //     </div>
    //   </section>

    //   <Footer />
    // </div>
  );
};

export default LandingPage;
